(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("zustand"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "zustand"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("zustand")) : factory(root["react"], root["zustand"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, (__WEBPACK_EXTERNAL_MODULE__5932__, __WEBPACK_EXTERNAL_MODULE__4596__) => {
return 